import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorId: null };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    const id = `ERR-${Date.now().toString(36).toUpperCase()}`;
    this.setState({ errorId: id });
    console.error("[ErrorBoundary]", id, error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-screen bg-[#272c39] text-white flex items-center justify-center px-4">
        <div className="max-w-md w-full text-center">
          <p className="text-6xl font-extrabold text-[#7269e3] font-unbounded mb-4">!</p>
          <h1 className="font-unbounded text-xl font-bold mb-3">Something went wrong</h1>
          <p className="text-white/60 text-sm leading-relaxed mb-8">
            An unexpected error occurred. Our team has been notified.
            {this.state.errorId && (
              <span className="block mt-2 font-mono text-xs text-white/40">
                {this.state.errorId}
              </span>
            )}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={() => this.setState({ hasError: false, errorId: null })}
              className="rounded-xl border border-white/20 px-5 py-2.5 text-sm font-semibold text-white/80 hover:bg-white/10 transition"
            >
              Try again
            </button>
            <a
              href="/"
              className="rounded-xl bg-[#7269e3] px-5 py-2.5 text-sm font-semibold text-white hover:brightness-110 transition"
            >
              Go home
            </a>
          </div>
        </div>
      </div>
    );
  }
}
